import { action, makeObservable, observable } from 'mobx';
import { notificationStore, betStore, gameConfigStore } from '@pascal/pascal-core';
import { marketsStore } from './marketsStore';
import { doBetStore } from './doBetStore';
import { gameActiveVideoStore } from './gameActiveVideoStore';
import { betSectionTabsName } from '../enums';

class GameStore {
  time = null;

  betShopTime = null;

  oddData = null;

  isBetsClosed = false;

  numPadData = { isOpen: false, sectionName: null, currentInputValue: null };

  timerDuration = 10;

  finishedOdd = null;

  isPongReceived = false;

  isUpperLayerShow = false;

  gameState = {
    status: '',
    isInitialLoaded: false,
  };

  roundId = '';

  isShowGameResultPopup = false;

  constructor() {
    makeObservable(this, {
      time: observable,
      betShopTime: observable,
      roundId: observable,
      isShowGameResultPopup: observable,
      oddData: observable.deep,
      gameState: observable,
      isPongReceived: observable,
      isUpperLayerShow: observable,
      finishedOdd: observable,
      numPadData: observable.deep,
      isBetsClosed: observable,
      timerDuration: observable,
      setTime: action.bound,
      setBetShopTime: action.bound,
      setOddData: action.bound,
      setGameState: action.bound,
      setNumPadData: action.bound,
      setFinishedOdd: action.bound,
      setIsBetsClosed: action.bound,
      setTimerDuration: action.bound,
      setIsPongReceived: action.bound,
      setUpperLayerToggle: action.bound,
      setIsShowGameResultPopup: action.bound,
      resetGameByGameTypeId: action.bound,
    });
  }

  setTime(time) {
    this.time = time;
  }

  setBetShopTime(time) {
    this.betShopTime = time;
  }

  setOddData(odd) {
    this.oddData = odd;
  }

  setRoundId(roundId) {
    this.roundId = roundId;
  }

  setUpperLayerToggle(bool) {
    this.isUpperLayerShow = bool;
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }

  setIsBetsClosed(isBetsClosed) {
    this.isBetsClosed = isBetsClosed;
  }

  setNumPadData(data) {
    this.numPadData = data;
  }

  setFinishedOdd(finishedOdd) {
    this.finishedOdd = finishedOdd;
  }

  setTimerDuration(timeValue) {
    this.timerDuration = timeValue;
  }

  setGameState(status) {
    this.gameState = status;
  }

  setIsShowGameResultPopup(status) {
    this.isShowGameResultPopup = status;
  }

  resetGameByGameTypeId() {
    // if (applicationStore.isDemo) {
    //   marketsStore.setCurrentClickedMarket('');
    //   betStore.setDemoBetHistory([]);
    //   userInfoStore.setDemoInitialBalance();
    //   doBetStore.updateTotalBetsAmount(0, true);
    // }
    this.setIsBetsClosed(false);
    betStore.setLiveBets([]);
    betStore.resetBetHistory();
    doBetStore.resetGameStates();
    marketsStore.setIsNexRoundBet(false);
    gameConfigStore.setMaxAutoCashOutOdd(null);
    doBetStore.updateBetSectionTabName(betSectionTabsName.markets);
    gameActiveVideoStore.resetLoadedVideosState();
    notificationStore.setNotificationType(null);
  }
}

export const gameStore = new GameStore();
